import type { Routes } from '@angular/router';
import { unsavedChangesGuard } from './data-filters/unsaved-changes.guard';

/**
 * Marketing → Data sub-tabs (manually uploaded data — prototype, no DB persistence).
 * Spread into the /marketing children in app.routes.ts; kept here so the redirect is unit-testable.
 */
export const MARKETING_DATA_ROUTES: Routes = [
  { path: 'data', redirectTo: 'data/feeds', pathMatch: 'full' },
  { path: 'data/feeds', loadComponent: () => import('./data-feeds/data-feeds.component').then(m => m.DataFeedsComponent) },
  {
    path: 'data/filters',
    loadComponent: () => import('./data-filters/data-filters.component').then(m => m.DataFiltersComponent),
    // Re-run the guard on ?edit= / ?mode= changes too, so switching filters asks about unsaved edits.
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canDeactivate: [unsavedChangesGuard],
  },
  // "Saved Filters" was merged into Filters (iteration 2); old links land there.
  { path: 'data/saved-filters', redirectTo: 'data/filters', pathMatch: 'full' },
  { path: 'data/settings', loadComponent: () => import('./data-settings/data-settings.component').then(m => m.DataSettingsComponent) },
];
